import { useMutation } from "@tanstack/react-query";
import { UserAttributionDto } from "@nestcoinco/hyper-api-gateway-api-client";

import { handleSaveAttribution } from "../../api-clients/userAccountClient";
import { clearAttributionData } from "../../utils/attribution";
import { QUERY_KEYS } from "../constants";
import Logger from "../../utils/logger";

function useSaveAttributionMutation() {
  const mutation = useMutation({
    mutationKey: [QUERY_KEYS.ATTRIBUTION.SAVE],
    mutationFn: (dto: UserAttributionDto) => handleSaveAttribution(dto),
    onSuccess: () => {
      clearAttributionData();
    },
    onError: (error) => {
      Logger.error(`Failed to save attribution data: ${error}`);
    },
  });

  return mutation;
}

export default useSaveAttributionMutation;
